import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import {
  CreateStandaloneInvoiceInput,
  standaloneInvoiceService,
} from '@services/standaloneInvoice';
import { getErrorMessage } from '@utils/errorMessage';

export const useCreateAndSendStandaloneInvoice = () => {
  return useMutation({
    mutationFn: (input: CreateStandaloneInvoiceInput) =>
      standaloneInvoiceService.createAndSend(input),
    onError: (error: any) => {
      toast.error(getErrorMessage(error, 'Failed to send invoice'));
    },
  });
};

export const useStandaloneInvoiceProjects = (
  organizationId?: string | null,
) => {
  return useQuery({
    queryKey: ['standaloneInvoiceProjects', organizationId],
    queryFn: () => {
      if (!organizationId) return [];
      return standaloneInvoiceService.getProjectsForOrganization(
        organizationId,
      );
    },
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000,
  });
};
